import { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";

export const ScrollableOddsList = ({ children }) => {
  const scrollRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  useEffect(() => {
    const element = scrollRef.current;
    if (!element) return;

    const handleWheel = (e) => {
      e.preventDefault();
      e.stopPropagation();
      const scrollSpeedMultiplier = 4;
      element.scrollLeft += e.deltaY * scrollSpeedMultiplier;
    };

    element.addEventListener("wheel", handleWheel, { passive: false });
    return () => element.removeEventListener("wheel", handleWheel);
  }, []);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleMouseUp = () => setIsDragging(false);
  const handleMouseLeave = () => setIsDragging(false);
  const preventTextSelection = (e) => {
    if (isDragging) {
      e.preventDefault();
    }
  };
  return (
    <Box
      ref={scrollRef}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseLeave}
      onDrag={preventTextSelection}
      sx={{
        display: "flex",
        overflowX: "auto",
        pb: 2,
        scrollBehavior: "smooth",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        scrollbarWidth: "none",
        userSelect: isDragging ? "none" : "auto",
        cursor: isDragging ? "grabbing" : "grab",
      }}
    >
      {children}
    </Box>
  );
};
